export default [
	{
		fontFamily: 'Sofia Sans',
		file: require('./fonts/SofiaSans-VariableFont_wght.ttf'),
	},
	{
		fontFamily: 'Sofia Sans Semi Condensed',
		file: require('./fonts/SofiaSansSemiCondensed-VariableFont_wght.ttf'),
	},
	{
		fontFamily: 'Sofia Sans Condensed',
		file: require('./fonts/SofiaSansCondensed-VariableFont_wght.ttf'),
	},
];
